import { render, staticRenderFns } from "./haoka.vue?vue&type=template&id=072c582b&scoped=true&"
import script from "./haoka.vue?vue&type=script&lang=js&"
export * from "./haoka.vue?vue&type=script&lang=js&"
import style0 from "./haoka.vue?vue&type=style&index=0&id=072c582b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072c582b",
  null
  
)

export default component.exports